// PrivacyPolicy.jsx
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import ERPChatbot from "../../components/ERPChatbot/ERPChatbot";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
  };

  return (
    <div className="privacy-page">
      <Header />

      {/* Hero Section */}
      <section className="privacy-hero">
        {/* <div className="privacy-hero-overlay">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">Effective Date: July 1, 2024</p>
        </div> */}
      </section>

      <main className="privacy-container">
        {/* Sections */}
        {[
          {
            title: "1. Information We Collect",
            items: [
              "Business data such as company name, location, and user roles",
              "User contact information (name, email, phone)",
              "Operational data from ERP modules like inventory, production, and sales",
            ],
          },
          {
            title: "2. How We Use Your Data",
            items: [
              "To enable core ERP/MES functionalities",
              "To improve software features and analytics",
              "To communicate important updates and support information",
            ],
          },
          {
            title: "3. Data Security",
            items: [
              "We use industry-standard encryption and secure servers to protect your data.",
            ],
          },
          {
            title: "4. Data Sharing",
            items: [
              "We do not sell or share your data with third parties without your consent.",
            ],
          },
          {
            title: "5. Cookies",
            items: [
              "We use cookies for session management and user experience improvements.",
            ],
          },
          {
            title: "6. Your Rights",
            items: [
              "You can request to view, update, or delete your data at any time.",
            ],
          },
        ].map((section, idx) => (
          <motion.section
            key={idx}
            className="privacy-section"
            variants={fadeIn}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            <h2>{section.title}</h2>
            <ul>
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </motion.section>
        ))}

        {/* CTA */}
        <motion.div
          className="privacy-cta"
          variants={fadeIn}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <h3>Have Questions?</h3>
          <p>
            If you have any concerns about how we handle your data, please{" "}
            <a href="/contact">contact our support team</a>.
          </p>
        </motion.div>
      </main>

      <Footer />
      <ERPChatbot />
    </div>
  );
}
